import React from 'react';
import PropTypes from 'prop-types';
import { b as breakpoints, M as MediaQuery } from './breakpoints-84fde671.js';

function Responsive({
  xs,
  sm,
  md,
  lg,
  children
}) {
  // don't ever render
  if (!xs && !sm && !md && !lg) return null;

  // always render
  if (xs && lg && !sm && !md || xs && lg && sm && md) return children;

  // if there are at least 2 breakpoints, find smallest and largest
  const smallest = xs && 'xs' || sm && 'sm' || md && 'md' || lg && 'lg';
  const largest = lg && 'lg' || md && 'md' || sm && 'sm' || xs && 'xs';
  const mediaQueryProps = {};

  // set minWidth/maxWidth based on which breakpoints were passed in
  if (smallest && largest && smallest !== largest) {
    if (breakpoints[smallest] && breakpoints[smallest].min) {
      mediaQueryProps.minWidth = breakpoints[smallest].min;
    }
    if (breakpoints[largest] && breakpoints[largest].max) {
      mediaQueryProps.maxWidth = breakpoints[largest].max;
    }
  } else if (smallest) {
    if (breakpoints[smallest] && breakpoints[smallest].max) {
      mediaQueryProps.maxWidth = breakpoints[smallest].max;
    }
    if (breakpoints[smallest] && breakpoints[smallest].min) {
      mediaQueryProps.minWidth = breakpoints[smallest].min;
    }
  }
  return /*#__PURE__*/React.createElement(MediaQuery, mediaQueryProps, children);
}
Responsive.defaultProps = {
  xs: false,
  sm: false,
  md: false,
  lg: false
};
Responsive.propTypes = {
  /** Whether to display in XS breakpoint */
  xs: PropTypes.bool,
  /** Whether to display in SM breakpoint */
  sm: PropTypes.bool,
  /** Whether to display in MD breakpoint */
  md: PropTypes.bool,
  /** Whether to display in LG breakpoint */
  lg: PropTypes.bool,
  /** content to render, can be function if we need access to breakpoint  */
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.node]).isRequired
};

export { Responsive as R };
